import script from "./Logout.vue?vue&type=script&setup=true&lang=js"
export * from "./Logout.vue?vue&type=script&setup=true&lang=js"

import "./Logout.vue?vue&type=style&index=0&id=41f527de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41f527de"]])

export default __exports__